import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep2 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-step2-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        <span className='text-pborange'>Tous les alliés de Marona sont des fantômes.</span> En utilisant
                        la commande <span className='text-pborange'>Combinage</span>, Marona peut les invoquer afin
                        qu'ils participent au combat !
                    </p>
                    <p className='mt-8'>
                        Une fois le combat engagé, sélectionnez la compétence{' '}
                        <span className='text-pborange'>Combinage</span> de Marona pour combiner vos alliés à{' '}
                        <span className='text-pborange'>des arbres, des fleurs, des rochers</span>, etc. présents sur la
                        carte.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="Le combinage est une technique spéciale qui ne peut être utilisée que par Marona. Marona peut utiliser le combinage un nombre illimité de fois, à n'importe quel moment de son tour."
                    />{' '}
                    <p className=' '>
                        <span className='text-pborange'>
                            Les statistiques de vos alliés changent selon le type d'objet auquel ils sont combinés.
                        </span>{' '}
                        ar conséquent, au moment de combiner vos alliés, il est utile de consulter l'
                        <span className='text-pborange'>icône</span> qui s'affiche sur l'objet. Ainsi, vous saurez d'un
                        simple coup d'œil quelles statistiques sont affectées.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="Si vous combinez Ash à cette fleur avec l'icône INT..."
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='...son INT augmentera !'
                    />{' '}
                    <p className=' '>
                        Les fantômes alliés ont un <span className='text-pborange'>nombre défini de tours</span>.
                        Assurez-vous de réfléchir <span className='text-pborange'>au moment et à l'endroit</span>{' '}
                        auxquels les combiner en fonction du nombre de tours dont ils disposent sur la carte.
                    </p>{' '}
                    <p className=' '>
                        Si besoin, vous pouvez utiliser la compétence <span className='text-pborange'>Con-fight !</span>{' '}
                        de Marona pour{' '}
                        <span className='text-pborange'>
                            augmenter le nombre de tours pendant lesquels un allié peut rester sur la carte
                        </span>{' '}
                        avant de disparaître !
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 4,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Utilisez la compétence de Marona pour augmenter le nombre de tours de vos alliés sur le champ de bataille !'
                    />{' '}
                </div>
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={4}
                />
            </section>
        </>
    )
}
